import React from 'react';
import { Skeleton, Stack } from '@mui/material';

const SiteObjects = React.memo(() => {
  return (
    <Stack>
      <Skeleton />
      <Skeleton />
      <Skeleton />
    </Stack>
  );
});

export { SiteObjects };
